
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-merchant/[article]",
      function () {
        return require("private-next-pages/help-merchant/[article]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-merchant/[article]"])
      });
    }
  